import { ProcessedCourse } from "@/common/course/types";
import getProgramPacing from "@/lib/program/utils/getProgramPacing";
import getTotalWeeks from "@/lib/program/utils/getTotalWeeks";

type BadgeTranslate = {
  (key: "selfPaced" | "instructorPaced" | "earnACertificate"): string;
  (key: "weeksCount", values: { count: number }): string;
};

export function getProgramBadgeInformation(
  courses: ProcessedCourse[],
  t: BadgeTranslate,
) {
  const pacingType = getProgramPacing(courses);
  const weeks = getTotalWeeks(courses);
  const duration = weeks ? t("weeksCount", { count: weeks }) : "";
  const level = courses[0]?.levelType || "Introductory";
  const hasCertificate = courses.some((course) =>
    course.entitlements?.some((e) => e.mode === "verified"),
  );

  return [
    { icon: "speedometer", header: level },
    {
      icon: "person",
      header:
        pacingType === "self_paced" ? t("selfPaced") : t("instructorPaced"),
    },
    { icon: "calendar-today", header: duration },
    ...(hasCertificate
      ? [{ icon: "certificate", header: t("earnACertificate") }]
      : []),
  ].filter((badge) => badge.header);
}

export function getCourseBadgeInformation(
  course: ProcessedCourse,
  t: BadgeTranslate,
) {
  const level = course?.levelType || "Introductory";
  const pacingType = course?.activeCourseRun?.pacingType;
  const pacing =
    pacingType === "self_paced"
      ? t("selfPaced")
      : pacingType === "instructor_paced"
        ? t("instructorPaced")
        : "";
  const weeks = course?.activeCourseRun?.weeksToComplete;
  const duration = weeks ? t("weeksCount", { count: weeks }) : "";
  const hasCertificate = course?.entitlements?.some(
    (e) => e.mode === "verified",
  );

  return [
    { icon: "speedometer", header: level },
    { icon: "person", header: pacing },
    { icon: "calendar-today", header: duration },
    ...(hasCertificate
      ? [{ icon: "certificate", header: t("earnACertificate") }]
      : []),
  ].filter((badge) => badge.header);
}
